<template>
  <header class="z-50 w-full px-5">
    <a
      href="#main-content"
      class="bypass-blocks-button bg-primary py-2 px-3 absolute text-white z-100 font-medium text-tiny md:text-sm outline-offset-[3px]"
      >{{ $t('wcag.skip_to_main_content') }}</a
    >

    <div class="flex h-[60px] md:h-header items-center">
      <!-- Mobile Dropdown -->
      <Menu as="div" class="relative min-w-[30px] md:min-w-0 shrink-0">
        <MenuButton
          class="flex md:hidden h-[35px] items-center justify-center rounded-control"
        >
          <FontAwesomeIcon
            :icon="['fal', 'bars']"
            class="text-2xl text-fg-ink"
          />
        </MenuButton>

        <MenuItems
          as="div"
          class="fixed top-[78px] left-0 w-full bg-[#3B1C54] border-t border-[#5B3397] px-7 pt-8 pb-10 text-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.1)] text-center"
        >
          <MenuItem
            as="a"
            class="mb-4 py-[6px] text-sm font-medium block"
            href="https://www.airlst.com/de/kontakt"
            target="_blank"
          >
            {{ $t('settings.contact_us') }}
          </MenuItem>

          <MenuItem
            as="div"
            class="mb-6 py-[6px] text-sm font-medium border border-white rounded-control"
            @click="router.get(useRoute('login'))"
          >
            {{ $t('auth.sign_in') }}
          </MenuItem>

          <MenuItem
            as="div"
            class="py-[6px] text-sm font-medium border border-primary bg-primary rounded-control"
            @click="router.get(useRoute('register'))"
          >
            {{ $t('auth.sign_up') }}
          </MenuItem>
        </MenuItems>
      </Menu>

      <div class="flex-1 flex justify-center md:justify-start">
        <div>
          <a :href="useRoute('dashboard')" aria-label="AirLST Logo">
            <img
              :src="Vapor.asset('images/airlst-logo-black.svg')"
              alt="airlst-logo"
              aria-label="AirLST Logo"
              class="md:mb-[4px] w-[135px] cursor-pointer"
              data-test="logo-img"
            />
          </a>
        </div>

        <div
          class="flex-1 hidden md:flex items-center justify-end gap-x-2 text-fg-ink"
        >
          <a
            as="a"
            class="py-[6px] px-6 text-sm font-medium block"
            href="https://www.airlst.com/de/kontakt"
            target="_blank"
            :aria-label="$t('settings.contact_us')"
          >
            {{ $t('settings.contact_us') }}
          </a>

          <button
            type="button"
            :aria-label="$t('auth.sign_in')"
            class="whitespace-nowrap py-[6px] px-6 text-sm font-medium border border-line-slate rounded-control text-center"
            @click="router.get(useRoute('login'))"
          >
            {{ $t('auth.sign_in') }}
          </button>

          <button
            type="button"
            :aria-label="$t('auth.sign_up')"
            class="whitespace-nowrap py-[6px] px-6 text-sm font-medium border border-primary bg-primary text-white rounded-control text-center"
            @click="router.get(useRoute('register'))"
          >
            {{ $t('auth.sign_up') }}
          </button>
        </div>
      </div>

      <div class="flex items-center justify-end shrink-0 md:ml-6">
        <SelectLanguage dropdown-class="top-[48px] rounded-none" />
      </div>
    </div>
  </header>
</template>

<script setup>
import SelectLanguage from '@/Components/Language/SelectLanguage.vue'
import { useRoute } from '@/composables/route'
import { router } from '@inertiajs/vue3'
import Vapor from 'laravel-vapor'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
</script>
